var map = {
	"./feature_buy_en.png": "2f1c",
	"./feature_buy_id.png": "7c97",
	"./feature_buy_my.png": "fbbd",
	"./feature_buy_ph.png": "5802",
	"./feature_buy_th.png": "ad25",
	"./feature_buy_zh.png": "bc83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8b9";